import { Stacker } from "~/common/components/Stacker/Stacker";
import { Icon } from "~/common/components/icon/Icon";
import { IconType } from "~/common/components/icon/IconType";
import { PopperTooltip } from "~/common/components/Tooltip";
import { useTranslation } from "react-i18next";
import { IMG_DMC_TEASER } from "~/utils/url/staticResources";

import classes from "./DesktopScanDMCTeaser.module.less";
import classNames from "classnames";
import { resetQualtrics } from "~/utils/misc";

interface Props {
  className?: string;
}

export const DesktopScanDMCTeaser = (props: Props) => {
  const { t } = useTranslation();
  return (
    <PopperTooltip
      className={classes.root}
      placement={"bottom"}
      innerClassName={"p-0"}
      tooltipContent={
        <Stacker gap={24} className={classNames(props.className, classes.tooltip)}>
          <h3 className={classes.title}>{t("qualtrics.scandmc.title")}</h3>
          <p>{t("qualtrics.scandmc.paragraph.1")}</p>
          <img src={IMG_DMC_TEASER} className={classes.image} />
          <Stacker gap={16}>
            {/*<p>{t("qualtrics.scandmc.paragraph.2")}</p>*/}
            <div id={"qualtricsScanning"} />
          </Stacker>
        </Stacker>
      }
      onTooltipOpened={resetQualtrics}
    >
      <Icon type={IconType.DmcScan} size={20} />
    </PopperTooltip>
  );
};
